<button
    mat-icon-button
    type="button"
    (click)="toggle($event)"
    [attr.aria-label]="'Hide password'"
    [attr.aria-pressed]="isHidden"
>
    <mat-icon>{{ icon }}</mat-icon>
</button>
